export default "__VITE_ASSET__CDjSBjxm__"